<app-loading-spinner
  *ngIf="isLoading"
  [loadingTitle]="loadingTitle"
  [loadingSubtitle]="loadingSubtitle"
  [overlay]="true"
></app-loading-spinner>

<div class="outer-container">
  <div id="tabs" #tabs>
    <ul class="nav nav-pills">
      <li class="nav-item">
        <a 
          class="nav-link active"
          [ngClass]="{ 'active active-tab':activeTab==='uploadList'}"
          (click)="switch('uploadList')"
          data-toggle="tab"
        >
          {{ "global.series-upload-list" | transloco }}
        </a>
      </li>
      <li class="nav-item" *appRequiredEntitlements="tableListEntitlement">
        <a 
          class="nav-link" 
          [ngClass]="{ 'active active-tab':activeTab==='additionalInfo'}" 
          data-toggle="tab"
          (click)="switch('additionalInfo')"
        >
        {{ "global.additional-info" | transloco }}
        </a>
      </li>
    </ul>
    <div class="tab-content">
      <div class="tab-pane"
        #uploadList 
        id="uploadList"
        [ngClass]="{ 'active':activeTab==='uploadList'}"
      >
      <form [formGroup]="form" (keyup.enter)="filterRows()">
        <div class="row row-cols-auto">
          <div class="col">
            <div class="form-group">
              <label for="baureihe">{{ "modules.data-management.table-header.series" | transloco }}</label>
              <ng-select
                [searchable]="true"
                notFoundText="{{ 'global.dropdown-not-found-text' | transloco }}" 
                [hideSelected]="true"
                [items]="seriesListOptions"
                bindLabel="brName" 
                bindValue="brName" 
                formControlName="baureihe"
                placeholder = "{{
                  'modules.data-management.filter.br-placeholder' | transloco
                }}">
              </ng-select>
              <ng-template ng-option-tmp let-item="item" let-index="index">
                {{ item.brName }}
              </ng-template>
            </div>
          </div>

           <div class="col">
            <div class="button-area">
              <button type="button" class="btn btn-primary" (click)="filterRows()">
                {{ "modules.data-management.filter.btn-search" | transloco }}
              </button>

              <button type="button" class="btn btn-secondary" (click)="resetFilteredRows()">
                {{ "modules.data-management.filter.btn-reset" | transloco }}
              </button>
            </div>
          </div>
        </div>
      </form>
      <br>
        <div class="tab-div">
          {{ "global.productive-from" | transloco }}
          &nbsp;
          <span (click)="switchSort()">
            <i class="sort-icon" *ngIf="!sortByAsc" class="bi bi-arrow-left"></i>
            <i class="sort-icon" *ngIf="sortByAsc" class="bi bi-arrow-right"></i>
          </span>
        </div>
        <div class="table-container">
          <table>
            <thead>
              <tr>
                <th class="fixed-column">{{ "global.series" | transloco }} ({{ 'global.shadow-model-series' | transloco }})</th>
                <th>{{ "global.SDP" | transloco }}</th>
                <th *appRequiredEntitlements="astaktEntitlement">{{ "global.astakt" | transloco }}</th>
                <th *ngFor="let date of productiveSince">{{ date }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let series of filteredSeriesList">
                <td class="fixed-column fixed-column-body">{{ series }}</td>
                <td>{{ getSDPFromSeriesList(series) }}</td>
                <td *appRequiredEntitlements="astaktEntitlement">{{ getastaktFromSeriesList(series) }}</td>
                <td *ngFor="let date of productiveSince">
                  <i class="version-icon" *ngIf="hasIcon(series, date)" class="bi bi-check-circle-fill"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="totalElements">
          {{ "global.total-record" | transloco}}: {{ baureiheDataLength }}
        </div>
      </div>
      <div 
        class="tab-pane" 
        id="additionalInfo" 
        [ngClass]="{ 'active':activeTab==='additionalInfo'}"
      >
        <app-fcsc-filter-upload-list
          (refreshVisibleTable)="setFilter($event)"
          [data]="serialUploadListData"
        >
        </app-fcsc-filter-upload-list>
        <div class="minimum-height"></div>
        <div class="row">
          <div class="col-12 round-button-container">
            <span 
              title="{{
                'global.download-csv' | transloco
              }}"
              (click)="downloadCSV()"
              class="main-icon"
            >
              <i class="bi bi-download"></i>
            </span>
          </div>
          <div class="col-12">
            <div class="vus-container">
              <ngx-datatable
                #dataTable
                class="material datatable-scrollable"
                [columnMode]="'flex'"
                [headerHeight]="56"
                rowHeight="auto"
                [scrollbarH]="false"
                [scrollbarV]="false"
                [rows]="serialUploadListData"
                [footerHeight]="56"
                (page)="setPage($event)"
                (sort)="sortCallback($event)"
                [sorts]="sortConfig"
                [messages]="{ emptyMessage: emptyMessage | transloco }"
              >
              <ngx-datatable-column
                name="{{ 'global.series' | transloco }} ({{ 'global.shadow-model-series' | transloco }})"
                prop="baureihe"
                [flexGrow]="6"
                [resizeable]="false"
              >
                <ng-template
                  let-value="value"
                  let-row="row"
                  ngx-datatable-cell-template
                >
                  <span *ngIf="value">{{ value }} {{createCommaSeperatedSchattenbaureihe(value)}}</span>
                </ng-template>

                <ng-template
                  let-value="value"
                  let-column="column"
                  let-rowIndex="rowIndex"
                  let-sort="sortFn"
                  ngx-datatable-header-template
                >
                  <span
                    class="header-sort"
                    ngbTooltip="{{
                      'modules.data-management.table-header.series'
                        | transloco : { value: value }
                    }}"
                    data-container="body"
                    container="body"
                    placement="bottom"
                    tooltipClass="note-tooltip"
                    (click)="sort()"
                    >{{ column.name }}</span
                  >
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column
                name="{{ 'global.SDP' | transloco }}"
                prop="name"
                [flexGrow]="7"
                [resizeable]="false"
              >
                <ng-template
                  let-value="value"
                  let-row="row"
                  ngx-datatable-cell-template
                >
                  <span *ngIf="value">{{ value }}</span>
                </ng-template>

                <ng-template
                  let-value="value"
                  let-column="column"
                  let-rowIndex="rowIndex"
                  let-sort="sortFn"
                  ngx-datatable-header-template
                >
                  <span
                    class="header-sort"
                    ngbTooltip="{{
                      'global.SDP-tooltip'
                        | transloco : { value: value }
                    }}"
                    data-container="body"
                    container="body"
                    placement="bottom"
                    tooltipClass="note-tooltip"
                    (click)="sort()"
                    >{{ column.name }}</span
                  >
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column
                *appRequiredEntitlements="astaktEntitlement"
                name="{{ 'global.astakt' | transloco }}"
                prop="asTakt"
                [flexGrow]="4"
                [resizeable]="false"
              >
                <ng-template
                  let-value="value"
                  let-row="row"
                  ngx-datatable-cell-template
                >
                  <span *ngIf="value">{{ value }}</span>
                </ng-template>

                <ng-template
                  let-value="value"
                  let-column="column"
                  let-rowIndex="rowIndex"
                  let-sort="sortFn"
                  ngx-datatable-header-template
                >
                  <span
                    class="header-sort"
                    ngbTooltip="{{
                      'global.astakt-tooltip'
                        | transloco : { value: value }
                    }}"
                    data-container="body"
                    container="body"
                    placement="bottom"
                    tooltipClass="note-tooltip"
                    (click)="sort()"
                    >{{ column.name }}</span
                  >
                </ng-template>
              </ngx-datatable-column>

                <ngx-datatable-column
                  name="{{ 'modules.data-management.serien-daten.upload-list.upload-date' | transloco }}"
                  prop="uploadDate"
                  [flexGrow]="5"
                  [resizeable]="false"
                >
                  <ng-template
                    let-value="value"
                    let-row="row"
                    ngx-datatable-cell-template
                  >
                    <span *ngIf="value">{{ value | date : "dd.MM.yy HH:mm:ss" }}</span>
                  </ng-template>

                  <ng-template
                    let-value="value"
                    let-column="column"
                    let-rowIndex="rowIndex"
                    let-sort="sortFn"
                    ngx-datatable-header-template
                  >
                    <span
                      class="header-sort local-time-subheader"
                      [attr.data-subtitle]="'global.local-time' | transloco"
                      ngbTooltip="{{
                        'modules.data-management.serien-daten.upload-list.upload-date'
                          | transloco : { value: value }
                      }}"
                      data-container="body"
                      container="body"
                      placement="bottom"
                      tooltipClass="note-tooltip"
                      (click)="sort()"
                      >{{ column.name }}</span
                    >
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column
                  name="{{
                    'global.productive-from'
                      | transloco
                  }}"
                  prop="inSeriesSinceSDP"
                  [flexGrow]="5"
                  [resizeable]="false"
                  [sortable]="true"
                >
                  <ng-template
                    let-value="value"
                    let-row="row"
                    ngx-datatable-cell-template
                  >
                    <span *ngIf="value">{{ value | date : "dd.MM.yy HH:mm:ss" }}</span>
                  </ng-template>

                  <ng-template
                    let-value="value"
                    let-column="column"
                    let-rowIndex="rowIndex"
                    let-sort="sortFn"
                    ngx-datatable-header-template
                  >
                    <span
                      class="header-sort local-time-subheader"
                      [attr.data-subtitle]="'global.local-time' | transloco"
                      ngbTooltip="{{
                        'global.productive-from'
                          | transloco : { value: value }
                      }}"
                      data-container="body"
                      container="body"
                      placement="bottom"
                      tooltipClass="note-tooltip"
                      (click)="sort()"
                      >{{ column.name }}</span
                    >
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column
                  [cellClass]="'text-right'"
                  name="{{
                    'modules.data-management.table-header.user'
                      | transloco
                  }}"
                  prop="username"
                  [flexGrow]="4"
                  [resizeable]="false"
                >
                  <ng-template
                    let-value="value"
                    let-row="row"
                    ngx-datatable-cell-template
                  >
                    <span *ngIf="value">{{ value }}</span>
                  </ng-template>

                  <ng-template
                    let-value="value"
                    let-column="column"
                    let-rowIndex="rowIndex"
                    let-sort="sortFn"
                    ngx-datatable-header-template
                  >
                    <span
                      class="header-sort"
                      ngbTooltip="{{
                        'modules.data-management.table-header.user'
                          | transloco : { value: value }
                      }}"
                      data-container="body"
                      container="body"
                      placement="bottom"
                      tooltipClass="note-tooltip"
                      (click)="sort()"
                      >{{ column.name }}</span
                    >
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column
                  [cellClass]="'text-right'"
                  name="{{
                    'modules.data-management.serien-daten.upload-list.requirement'
                      | transloco
                  }}"
                  prop="requirement"
                  [flexGrow]="3"
                  [resizeable]="false"
                >
                  <ng-template
                    let-value="value"
                    let-row="row"
                    ngx-datatable-cell-template
                  >
                    <span *ngIf="value">{{ value }}</span>
                  </ng-template>

                  <ng-template
                    let-value="value"
                    let-column="column"
                    let-rowIndex="rowIndex"
                    let-sort="sortFn"
                    ngx-datatable-header-template
                  >
                    <span
                      class="header-sort"
                      ngbTooltip="{{
                        'modules.data-management.serien-daten.upload-list.tooltip.requirement'
                          | transloco : { value: value }
                      }}"
                      data-container="body"
                      container="body"
                      placement="bottom"
                      tooltipClass="note-tooltip"
                      (click)="sort()"
                      >{{ column.name }}</span
                    >
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column
                  name="{{ 'global.comment' | transloco }}"
                  prop="comment"
                  [flexGrow]="5"
                  [resizeable]="false"
                >
                  <ng-template
                    let-value="value"
                    let-row="row"
                    ngx-datatable-cell-template
                  >
                    <span
                      *ngIf="value"
                      class="text-pre-wrap"
                      placement="bottom"
                      [ngbTooltip]="value"
                      data-container="body"
                      container="body"
                      tooltipClass="note-tooltip"
                      >{{ truncateNote(value) }}
                    </span>
                  </ng-template>

                  <ng-template
                    let-value="value"
                    let-column="column"
                    let-rowIndex="rowIndex"
                    let-sort="sortFn"
                    ngx-datatable-header-template
                  >
                    <span
                      class="header-sort"
                      ngbTooltip="{{
                        'modules.data-management.table-header.comment'
                          | transloco : { value: value }
                      }}"
                      data-container="body"
                      container="body"
                      placement="bottom"
                      tooltipClass="note-tooltip"
                      (click)="sort()"
                      >{{ column.name }}</span
                    >
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column
                  [cellClass]="'text-center'"
                  name="{{ 'global.actions' | transloco }}"
                  [flexGrow]="3"
                  [sortable]="false"
                  [resizeable]="false"
                >
                  <ng-template
                    let-rowIndex="rowIndex"
                    let-row="row"
                    let-value="value"
                    ngx-datatable-cell-template
                  >
                    <span 
                      title="{{
                        'modules.data-management.serien-daten.upload-list.modal.title'
                          | transloco
                      }}"
                      (click)="editSerialListRecord(row)"
                    >
                      <i class="bi bi-pencil"></i>
                    </span>
                  </ng-template>

                  <ng-template
                    let-value="value"
                    let-column="column"
                    let-rowIndex="rowIndex"
                    ngx-datatable-header-template
                  >
                    <span
                      ngbTooltip="{{
                        'global.actions' | transloco : { value: value }
                      }}"
                      data-container="body"
                      container="body"
                      placement="bottom"
                      tooltipClass="note-tooltip"
                      >{{ column.name }}</span
                    >
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-footer *ngIf="true">
                  <ng-template
                    ngx-datatable-footer-template
                    let-rowCount="rowCount"
                    let-pageSize="pageSize"
                    let-selectedCount="selectedCount"
                    let-offset="offset"
                    let-curPage="curPage"
                  >
                    <div class="col-8">
                      <datatable-pager
                        [pagerLeftArrowIcon]="'datatable-icon-left'"
                        [pagerRightArrowIcon]="'datatable-icon-right'"
                        [pagerPreviousIcon]="'datatable-icon-prev'"
                        [pagerNextIcon]="'datatable-icon-skip'"
                        [count]="response?.totalElements || 0"
                        [page]="page.pageNumber"
                        [size]="page.size"
                        (change)="setPage($event)"
                      >
                      </datatable-pager>
                    </div>

                    <div class="col-4 page-result-section server-side">
                      <span class="float-end">
                        <span class="result-text">{{
                          "components.footer.result-per-page" | transloco
                        }}</span>
                        <span
                          class="result-value"
                          [ngClass]="{ active: page.size === 100 }"
                          (click)="setPageSize(100)"
                          >100</span
                        >
                        <span>
                          {{ "components.footer.files" | transloco }}:
                          {{
                            serialUploadListData && serialUploadListData.length > 0
                              ? (response?.number || 0) * page.size + 1
                              : 0
                          }}
                          -
                          {{
                            (response?.number || 0) * page.size + serialUploadListData.length
                          }}
                        </span>
                        <span>
                          {{ "components.footer.of" | transloco }}
                          {{
                            serialUploadListData?.length || 0
                          }}</span
                        >
                      </span>
                    </div>
                  </ng-template>
                </ngx-datatable-footer>
              </ngx-datatable>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
